<h1 mat-dialog-title class="title">{{ data.title }}</h1>
<mat-dialog-content class="mat-typography content">
  @if (isHtml) {
    <div class="data-entry" [innerHTML]="data.message"></div>
  }
  @if (!isHtml) {
    <div class="data-entry">
      {{ data.message }}
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end" class="actions">
  <button mat-button class="confirm" (click)="onSubmit()">Confirm</button>
  <button mat-button class="close" mat-dialog-close (click)="onCancel()">
    Cancel
  </button>
</mat-dialog-actions>
